import React, { Suspense } from 'react';
import { StyledLayout } from './Layout.styles';
import SideBar from '../SideBar';
import Header from '../Header';
import ChatHeader from '../ChatHeader';
import Loaders from '../Loaders';
import { useContextHook } from 'use-context-hook';
// import CenterModal from '@/Modal/CenterModal';
// import OtpComponent from '@/Otp/OtpComponent';
import { useLocation } from 'react-router-dom';

const Layout = ({ children, showTemplate, user }) => {
  const location = useLocation();
  const renderHeader = () => {
    switch (location?.pathname) {
      case '/dashboard':
      case '/get-started':
        return <Header />;
      case '/chat':
        return <ChatHeader />;
      case '/upgrade-plan':
        return '';
      default:
        return <Header />;
    }
  };

  return (
    <StyledLayout $showlayout={showTemplate}>
      <span className="overlay" />
      {showTemplate ? (
        <>
          <SideBar />
          <div className="children">
            {renderHeader()}
            <Suspense fallback={<Loaders viewLoader />}>{children}</Suspense>
          </div>
        </>
      ) : (
        <div className="children">{children}</div>
      )}
    </StyledLayout>
  );
};

export default Layout;
